<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>积分任务</el-breadcrumb-item>
        <el-breadcrumb-item>任务列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">任务列表</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleTaskCreate"
          >添加任务</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="任务名称"
          prop="name"
        >
          <el-input
            v-model="query.name"
            placeholder="输入任务名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务编码"
          prop="code"
        >
          <el-input
            v-model="query.code"
            placeholder="输入任务编码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务类型"
          prop="type"
        >
          <el-select
            v-model="query.type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filter.types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="任务名称"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="code"
            label="任务编码"
            min-width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="reward"
            label="任务积分"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="day_times"
            label="单日最大操作次数"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.type == 1 ? '奖励' : '消耗'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToGroupEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToGroupRemove(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToGroupEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToGroupRemove(scope.row, scope.$index)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <TaskCreate
      :visible="createDialog"
      @close="createDialog = false"
      @submit="fetchGroupList"
    ></TaskCreate>
    <TaskEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchGroupList"
    ></TaskEdit>
  </div>
</template>

<script>
import TaskCreate from '@/components/dialog/pointsTask/TaskCreate'
import TaskEdit from '@/components/dialog/pointsTask/TaskEdit'
import { pointsTaskList, pointsTaskDestroy } from '@/api/operation'

export default {
  components: {
    TaskCreate,
    TaskEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        name: '',
        code: '',
        type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        types: [
          { label: '全部', value: '' },
          { label: '奖励', value: '1' },
          { label: '消耗', value: '2' }
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    }
  },
  created() {
    this.parseQuery()
    this.fetchGroupList()
  },
  methods: {
    // QQ群列表请求
    fetchGroupList() {
      pointsTaskList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchGroupList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchGroupList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchGroupList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchGroupList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '2': '关闭'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // qq群创建
    handleTaskCreate() {
      this.createDialog = true
    },
    // qq群编辑
    handleToGroupEdit(row) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      this.editDialog = true
    },
    // qq群删除
    handleToGroupRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        pointsTaskDestroy({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchGroupList()
        })
      }).catch(() => { })
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
